import React, { useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";
export const MainD = styled.div`
  /* display: grid; */
  /* grid-template-columns: repeat(5, 56px); */
  /* grid-gap: 9px; */
  /* grid-row-gap: 18px; */
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: space-between;
  height: 338px;

  margin-bottom: 18px;
`;
export const Pill = styled.div`
  position: relative;
  width: 56px;
  height: 160px;
  border-radius: 38px;
  background-color: #413f62;
  ${(p) => (p.downRow ? "transform: rotate(180deg) scaleX(-1)" : null)};
  overflow: visible;
`;

const fadeInAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.55, 0, 0.13, 0.93);
    transform: scale(0);
  }
  50% {
    transition-timing-function: cubic-bezier(0.27, 0.41, 0.6, 1);
    transform: scale(1.0808);
  }
  100%{
     transform: scale(1);
     opacity:1;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 283ms 1 forwards
`;

const scaleFadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.17, 0.12, 0, 1);
    transform:scale(1);
  }
  
  100%{
    transform:scale(1.5);
    } 
`;
const opacityOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
    opacity:1;
  }
  
  100%{
      opacity:0;
   } 
`;
const fadeOut = css`
  ${scaleFadeOutAnim} 283ms 1 forwards,  ${opacityOutAnim} 250ms 1 forwards
`;

const BallD = styled.div`
  background-color: ${(p) => p.color};
  animation: ${css`
    ${fadeInAnim} 283ms ${(p) => p.delay} 1 forwards
  `};
  animation: ${(p) => (p.fadeOut ? fadeOut : null)};
  transform: scale(0);
  /* display: flex;
  justify-content: center;
  align-items: center; */

  width: 56px;
  height: 56px;
  border-radius: 38px;
`;
const DifferentD = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.fadeOut ? fadeOut : null)};

  transform: scale(0);

  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background: #de4d78;

  && > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    border-radius: 19px;
    background: #e1be27;
    z-index: 1;
    div {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      background: #8cbb67;
      z-index: 2;
    }
  }
`;

const moving = keyframes`
    0%{
      transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
      transform: translateY(0) scale(1);
    }

    100%{
       transform: translateY(108px) scale(1);
      } 
  `;
const scaling = keyframes`
    0%{
      transition-timing-function: linear;
      transform: translateY(108px) scale(1);
    }
    50% {
      transition-timing-function: linear;
      transform: translateY(108px) scale(1.1);
    }
    100%{
       transform: translateY(108px) scale(1);
      } 
  `;

const scaleAnim = css`
  ${scaling} 1000ms infinite
`;
const moveAnim = css`
  ${moving} 367ms forwards
`;
const Moving = styled.div`
  position: absolute;
  animation: ${(p) => (p.move ? moveAnim : null)};
  animation: ${(p) => (p.move && p.canScale ? scaleAnim : null)};
  overflow: visible;
  padding: 4px;
  margin-left: -4px;
  margin-top: -4px;
`;

export const Ball = ({
  isDifferent,
  color,
  move,
  fadeOut,
  delay,
  canScale,
}) => {
  const [isMoving, setisMoving] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setisMoving(move);
    }, 367);
  }, [move]);

  return (
    <Moving move={isMoving} canScale={canScale} className="moving">
      {isDifferent ? (
        <DifferentD fadeOut={fadeOut} className="DifferentD">
          <div>
            <div></div>
          </div>
        </DifferentD>
      ) : (
        color !== "0" && (
          <BallD color={color} fadeOut={fadeOut} delay={delay}>
            {/* <div>
              <div></div>
            </div> */}
          </BallD>
        )
      )}
    </Moving>
  );
};
